import React from "react";

// Icons for each platform. "Link" is the generic fallback.
export const PLATFORM_ICONS = {
  Email: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7l-10 6L2 7"/></svg>
  ),
  LinkedIn: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zM8.34 18.34V9.99H5.67v8.35h2.67zM7 8.82a1.55 1.55 0 100-3.1 1.55 1.55 0 000 3.1zm11.34 9.52v-4.57c0-2.45-1.31-3.59-3.06-3.59-1.41 0-2.04.78-2.39 1.32v-1.13h-2.67v8.35h2.67v-4.66c0-.25.02-.49.09-.67.2-.49.65-1 1.4-1 .99 0 1.39.75 1.39 1.86v4.47h2.67z"/></svg>
  ),
  Instagram: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
  ),
  Behance: (
    <span style={{ fontWeight: 700, fontSize: "1.2rem", lineHeight: 1 }}>Bē</span>
  ),
  Fiverr: (
    <span style={{ fontWeight: 700, fontSize: "1.4rem", lineHeight: 1 }}>fi</span>
  ),
  Etsy: (
    <span style={{ fontWeight: 700, fontSize: "1.3rem", lineHeight: 1 }}>E</span>
  ),
  Patreon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><circle cx="15" cy="9" r="6"/><rect x="2" y="3" width="3.5" height="18"/></svg>
  ),
  YouTube: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l5 3-5 3z" fill="currentColor"/></svg>
  ),
  X: (
    <span style={{ fontWeight: 700, fontSize: "1.3rem", lineHeight: 1 }}>𝕏</span>
  ),
  ArtStation: (
    <span style={{ fontWeight: 700, fontSize: "1.2rem", lineHeight: 1 }}>A</span>
  ),
  Website: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 010 18M12 3a15 15 0 000 18"/></svg>
  ),
  Link: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><path d="M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1"/><path d="M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1"/></svg>
  ),
};

// The platforms a user can pick from in the admin dropdown.
export const PLATFORM_OPTIONS = [
  "Email", "LinkedIn", "Instagram", "Behance", "Fiverr",
  "Etsy", "Patreon", "YouTube", "X", "ArtStation", "Website", "Link",
];

// Shown only until the user saves their own contacts in the admin.
export const fallbackContacts = [
  { platform: "Email", label: "Email", desc: "Send me your idea or project details and I'll get back to you.", value: "hello@sprykal.com" },
  { platform: "LinkedIn", label: "LinkedIn", desc: "Connect with me on LinkedIn for updates and behind-the-scenes.", value: "linkedin.com/in/sprykal" },
  { platform: "Fiverr", label: "Fiverr", desc: "Check out my services or request a custom commission.", value: "fiverr.com/sprykal" },
];
